import { useLocation, useNavigate } from 'react-router-dom';
import { useActivateMutation } from '@src/features/auth/redux';
import { routesConfig } from '@src/core/routes';
import { toast } from 'react-toastify';

export const useActivateUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activate, { isLoading }] = useActivateMutation();

  const onActivate = () => {
    const params = new URLSearchParams(location.search);
    const key = params.get('key');

    if (!key) return;

    activate({ key }).unwrap()
      .then(() => {
        navigate(routesConfig.signIn, { replace: true });
        toast.success('success');
      })
      .catch(() => {});
  };

  return {
    onActivate,
    isLoading,
  };
};

